import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Button } from 'reactstrap';
import { CSVLink } from "react-csv";

import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../components/DatatablePagination';

const MessengerClickStats = ({ labels, data, fromDate, toDate }) => {
    const [csvData, setCSVData] = useState([]);
    useEffect(() => {
        var tablePrint = [
            {
                r1: "", r2: "Popular Menu Items"
            },
            {},
            {
                r1: "Start Date :" + fromDate,
                r2: "End Date :" + toDate
            },
            {},
            {
                r1: "Title",
                r2: "Clicks"
            },
        ];
        if (data.length > 0) {
            data.map(elem => {
                tablePrint.push({
                    r1: elem.title,
                    r2: elem.clicks
                })
            });
        }
        setCSVData(tablePrint);
    }, [data]);
    return (
        <Card>
            <div style={{ padding: '15px' }}>
                <div className="float-left float-none-xs">
                    <div className="d-inline-block">
                        <h5 className="d-inline"><IntlMessages id="dashboards.messenger-stats" /></h5>
                        <span className="text-muted text-small d-block">
                            <IntlMessages id="dashboards.messenger-stats-topic-view" />
                        </span>
                    </div>
                </div>
                <div className='float-right'>
                    <CSVLink data={csvData} headers={[
                        { key: "r1", label: "" },
                        { key: "r2", label: "" }
                    ]} filename="popular-menu-items.csv">
                        <Button
                            color="primary"
                            outline
                            size="xs"
                        >
                            Download
                        </Button>
                    </CSVLink>
                </div>
            </div>
            <CardBody>
                <ReactTable
                    data={data}
                    columns={labels}
                    defaultPageSize={5}
                    filterable={false}
                    showPageJump={true}
                    PaginationComponent={DataTablePagination}
                    showPageSizeOptions={true}
                    defaultSorted={[
                        {
                            id: 'clicks',
                            desc: true,
                        },
                    ]}
                />
            </CardBody>
        </Card>
    );
};

export default MessengerClickStats;
